
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator'

@Component
export default class AppButtonSelection extends Vue {
    @Prop() options!: string[];
    @Prop() closeButtons!: boolean;
    @Prop({default: ''}) option!: string;
    @Prop({ default: false }) disableButtonCss!: boolean;

    selectedOption: string  = this.option;

    hasOptionSelected(option: string) {
        if (option == this.selectedOption) {
            return true;
        }
    }

    selectOption(option: string) {
        this.selectedOption = option;
        this.$emit('optionSelected', option);
    }
};
